import * as moment from 'moment';

import {
  Inject,
  OnInit,
  Component,
} from 'ng-metadata/core';

import checkoutTimerHtml from './checkout-timer.html';
import './checkout-timer.scss';

@Component({
  selector: 'gw-checkout-timer',
  template: checkoutTimerHtml,
})
export class CheckoutTimerComponent implements OnInit {

  public endTime;
  public listener;
  public enabled = false;

  constructor(
    @Inject('$scope') private $scope: ng.IScope,
    @Inject('$sessionStorage') protected $storage,
  ) {}

  ngOnInit() {
    this.endTime = this.$storage.checkoutEndTime;

    // If end time was already set, start timer right away
    if (this.endTime) {
      this.enabled = true;
    }

    // Bind event
    this.listener = this.$scope.$on('display-timer', () => {
      this.enabled = true;

      if (! this.endTime) {
        this.endTime = moment().add(15, 'minutes').valueOf();
        this.$storage.checkoutEndTime = this.endTime;
      }
    });
  }

  /**
   * Component destroyed
   */
  ngOnDestroy() {
    // Unbind event listener to save memory
    this.listener();
  }

  /**
   * Clear saved timer so it resets if user tries again
   */
  clearTimer() {
    delete this.$storage.checkoutEndTime;
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/common/checkout-timer/checkout-timer.component.ts